module.exports = __webpack_public_path__ + "static/media/social-security.19777dc2.svg";